import type Decimal from "decimal.js";
import Link from "next/link";
import SVGAtom from "~/components/Atoms/SVGAtom/SVGAtom";

type TokenRouteProps = {
  icon: React.ComponentProps<typeof SVGAtom>["iconName"];
  routeLabel: string;
  href: string;
  isNewTab?: boolean;
};

type Props = {
  pointBalance: number;
  swapBalance: number;
  routes?: TokenRouteProps[];
};

export const MyPageAssetModule = (props: Props) => {
  return (
    <div className="flex w-full flex-col items-center gap-[16px] px-[20px]">
      <div className="flex flex-col items-center gap-[12px] self-stretch py-[4px]">
        <p className="self-stretch text-[13px] leading-[22px]">Asset</p>
      </div>
      <div className="flex min-w-[335px] flex-col items-start gap-[4px] self-stretch rounded-[14px] bg-[#f0f5ff] px-[20px] py-[16px]">
        <div className="flex items-center justify-between self-stretch">
          <p className="text-[20px] font-extrabold leading-[24px] text-[#434343]">
            Fan Point
          </p>
          <div className="flex flex-col items-start">
            <div className="flex items-start justify-center gap-[4px]">
              <p className="text-[17px] font-semibold leading-[26px] text-blue">
                {Number(props.pointBalance).toLocaleString()}
              </p>
              <p className="text-[17px] font-normal leading-[26px] text-[rgba(0,0,0,0.85)]">
                FAO
              </p>
            </div>
            <p className="text-[13px] font-medium leading-[16px]">
              (={props.swapBalance.toLocaleString()} FAND)
            </p>
          </div>
        </div>
      </div>
      {props.routes && (
        <div className="flex w-full flex-row items-center justify-between px-[20px]">
          {props.routes.map((route, index) => (
            <>
              <Link
                scroll={false}
                href={route.href}
                className="flex flex-col items-center"
                key={route.icon}
                target={route.isNewTab ? "_blank" : "_self"}
              >
                <div className="flex h-[60px] w-[60px] items-center justify-center p-[18px]">
                  <SVGAtom
                    iconName={route.icon}
                    width={24}
                    height={24}
                    color="#000"
                  />
                </div>
                <p className="text-[13px] font-medium leading-[16px]">
                  {route.routeLabel}
                </p>
              </Link>
              {props.routes && index !== props.routes.length - 1 && (
                <div className="h-[50px] w-[1px] bg-[#0000000F]" />
              )}
            </>
          ))}
        </div>
      )}
    </div>
  );
};
